import { AttributeValueSelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  attribute_value_product_shop_items: {
    'ui:options': {
      copyable: true,
      orderable: false,
    },
    items: {
      attribute_value_id: {
        'ui:widget': AttributeValueSelectionWidget,
      },
      price_change_value: {
        'ui:options': {
          adornment: 'تومان',
          convertToWord: true,
        },
      },
    },
  },
});

export default uiSchema;
